import { useCallback } from 'react'
import { FieldSettingsMap } from '@user/store/entityFormSettings'
import { FormikErrors } from 'formik'
import { ILeadFormModel } from '@user/components/Leads/AddLeadPage/typings'
import {
  addLeadFieldsToCheckNonRequiredErrors,
  EntityFormFieldNameEnums,
} from '@user/components/Settings/EntityFormSettings'
import { useSelectCustomFieldData } from '@user/store/customFields'

export interface Props {
  setHideOptional: (status: boolean) => void
  settings: FieldSettingsMap
  errors: FormikErrors<ILeadFormModel>
  values: ILeadFormModel
}

export const useNonRequiredFieldValidate = (props: Props) => {
  const { setHideOptional, settings, errors } = props
  const { customSettings } = useSelectCustomFieldData()

  const checkNonRequiredErrors = useCallback(() => {
    let nonRequiredHasErrors = false
    const { createNewLocation } = props.values

    addLeadFieldsToCheckNonRequiredErrors.forEach((field) => {
      if (
        createNewLocation &&
        field.name === EntityFormFieldNameEnums.Address
      ) {
        return
      }

      const [isRequired, hasEnabled] = settings.get(field.name) ?? [
        false,
        false,
      ]
      const fieldErrors = field.errorFields.filter(
        (errorField) => errors[errorField] !== undefined,
      )

      if (!isRequired && hasEnabled && fieldErrors.length > 0) {
        nonRequiredHasErrors = true
      }
    })

    customSettings.map((cs) => {
      if (!cs.required && cs.enabled) {
        for (const field in errors.customFields?.number) {
          if (field === cs.customFieldId.toString()) nonRequiredHasErrors = true
        }
      }
    })

    if (nonRequiredHasErrors) setHideOptional(!nonRequiredHasErrors)

    return nonRequiredHasErrors
  }, [setHideOptional, settings, errors, customSettings, props.values])

  return {
    checkNonRequiredErrors,
  }
}
